module.exports = __webpack_public_path__ + "static/media/focus-keyvisualbg.e1dab84d.jpg";